import { computed, inject } from '@angular/core';
import { BOOK_KIT_ROUTES } from '@marineform/book-kit-data-access';
import { FeatureFlag, FeatureFlagsStore } from '@marineform/fe-data-access';
import { signalStore, withComputed } from '@ngrx/signals';
import { MANAGE_PATHS } from '../data/manage-paths';
import { SessionKindEnum } from '../enums/session-kind.enum';
import { manageAbsolutePath } from '../helpers/manage-absolute-path';
import { AuthStore } from './auth.store';

/**
 * Session-derived home path for manage vs market surfaces.
 */
export const AppSurfaceStore = signalStore(
  { providedIn: 'root' },
  withComputed((
    _store,
    featureFlags = inject(FeatureFlagsStore),
    authStore = inject(AuthStore),
  ) => ({
    /**
     * Where this session belongs on root navigation.
     */
    homePath: computed(() => {
      const sessionKind = authStore.sessionKind();
      if (sessionKind === SessionKindEnum.OPERATOR) {
        return manageAbsolutePath(MANAGE_PATHS.HOME);
      }

      const marketEnabled = featureFlags.isEnabled(FeatureFlag.EnableMarket);
      if (marketEnabled) {
        return `/${BOOK_KIT_ROUTES.HOME}`;
      }

      return `/${MANAGE_PATHS.LOGIN}`;
    }),
  })),
);
